import Select, { components } from 'react-select';

const CustomMenuList = (props) => {
  return (
    <>
      <components.MenuList {...props}>
        {props.children}
        {/* Separator style */}
        {/* <div style={{ margin: '8px 0', borderBottom: '1px solid #ddd' }} />  */}
        
        {/* Custom "Create New" button/item */}
        <div
          onClick={props.handleCreateNew}
          style={{
            borderTop: '1px solid #ddd', 
            margin: '4px 0',
            position: 'sticky',
            bottom: 0,
            cursor: 'pointer',
            textAlign: 'center',
          }}
          //padding: '8px 12px',
          //backgroundColor: '#f4f4f4',
          // Prevents the dropdown from closing when clicking the button
          onMouseDown={e => e.stopPropagation()} 
        >
          {/* <components.Option value='create_new' label='+ Create New' /> */}
          + Create New
        </div>
      </components.MenuList>
      {/* <div style={{ position: 'absolute', bottom: 0, borderTop: '1px solid #ddd', margin: '4px 0' }}>
        + Create New
      </div> */}
    </>
  );
};

const CustomOption = (props) => {
  // Check if this is the "Create New" option based on its value or label
  const isCreateOption = props.data.value === 'create_new';

  if(!isCreateOption)
    return ( <components.Option {...props} /> );
  else
    return (
      <div style={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', borderTop: '1px solid #ddd' }}>
        <components.Option {...props} />
      </div>
  );
    
};

export function CreateNewSelect(props) {
  const options = [...props.options, { value: 'create_new', label: props.createNewLabel ?? "+ Create New" }]

    return (
        <Select
          {...props}
          components={{ Option: CustomOption }}
          options={options}
          placeholder={props.placeholder ?? "Select an option..."}
        />
    );
}